/**
 * Buscar sin que importen las tildes ni las mayúsculas: «acetaminofen» encuentra «Acetaminofén».
 * Lo usa el buscador de productos y la búsqueda avanzada de medicamentos.
 */

/** El texto en minúsculas y sin tildes (la ñ se conserva: «año» no es «ano»). */
export function sinTildes(texto) {
  return String(texto === undefined || texto === null ? "" : texto)
    .normalize("NFD")
    .replace(/ñ/g, "\u0001")
    .replace(/Ñ/g, "\u0001")
    .replace(/[̀-ͯ]/g, "")
    .replace(/\u0001/g, "ñ")
    .toLowerCase();
}

/**
 * Un patrón de expresión regular (sin banderas) que acepta cualquier tilde en las vocales y toma lo
 * escrito tal cual: un paréntesis o un punto no rompen la búsqueda.
 */
export function patronSinTildes(texto) {
  return sinTildes(texto)
    .replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
    .replace(/a/g, "[aáàäâ]")
    .replace(/e/g, "[eéèëê]")
    .replace(/i/g, "[iíìïî]")
    .replace(/o/g, "[oóòöô]")
    .replace(/u/g, "[uúùüû]");
}
